import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Activity, RefreshCw, Radio } from "lucide-react";
import { toast } from "sonner";
import { fmtTime } from "./shared";

export default function EngineBar({ engine, onTick }) {
  const [running, setRunning] = useState(false);
  const run = async () => {
    setRunning(true);
    try {
      const { data } = await api.post("/engine/tick");
      toast.success(`Engine ran: ${data.sent} sent · ${data.replies} replies · ${data.deferred} deferred`);
      onTick();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setRunning(false); }
  };
  return (
    <div className="flex items-center gap-6 px-6 h-10 border-b border-border bg-muted/20 text-xs" data-testid="engine-bar">
      <div className="flex items-center gap-2 text-muted-foreground"><Radio className="w-3.5 h-3.5 text-emerald-500" /><span className="font-medium text-foreground">Scheduler</span> every {engine?.interval_seconds || 60}s</div>
      <div className="text-muted-foreground">Last run <span className="mono text-foreground" data-testid="engine-last-tick">{fmtTime(engine?.last_tick)}</span></div>
      <div className="text-muted-foreground">Active <span className="mono text-foreground" data-testid="engine-active">{engine?.active_enrollments ?? 0}</span></div>
      <div className="text-muted-foreground">Next send <span className="mono text-foreground" data-testid="engine-next">{fmtTime(engine?.next_send_at)}</span></div>
      <div className="text-muted-foreground flex items-center gap-1"><Activity className="w-3.5 h-3.5" />Tracking {engine?.tracking_enabled ? <span className="text-emerald-500">on</span> : <span className="text-amber-500">off (set PUBLIC_URL)</span>}</div>
      <Button variant="outline" size="sm" className="ml-auto h-7 text-xs" onClick={run} disabled={running} data-testid="engine-run-now"><RefreshCw className={`w-3.5 h-3.5 mr-1.5 ${running ? "animate-spin" : ""}`} />Run now</Button>
    </div>
  );
}
